import React from "react";

import classnames from "classnames/bind";

import styles from "./DotSpinner.module.scss";

const cx = classnames.bind(styles);

type SpinnerSize = "large" | "medium" | "small";

export function DotSpinner({
    color = "#4eb0c2", //
    size = "large",
}: Props) {
    return (
        <div
            className={cx("dot-spinner", {
                large: size === "large",
                medium: size === "medium",
                small: size === "small",
            })}
        >
            {[1, 2, 3, 4, 5, 6, 7, 8].map((dot: number) => {
                return (
                    <div
                        key={dot}
                        style={
                            {
                                "--color": color,
                            } as React.CSSProperties
                        }
                        className={cx("dot")}
                    />
                );
            })}
        </div>
    );
}

interface Props {
    color?: React.CSSProperties["color"];
    size?: SpinnerSize;
}
